export default {
  donationGroups: [],
  donationGroupCount: 0,
  donationGroup: {}
}